import { Component, OnInit, ViewChildren, QueryList, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { map } from 'rxjs/operators';
import { saveAs as importedSaveAs } from "file-saver";
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { Constants } from '../../../../_utils/Constants';






const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);
//console.log("datecur :",  currentdat);
export interface DialogData {
  setValue: string,
  setRole: string
}
@Component({
  selector: 'app-entity-consent-template-report',
  templateUrl: './entity-consent-template-report.component.html',
  styleUrls: ['./entity-consent-template-report.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class EntityConsentReportComponent implements OnInit {
  maxDate: Date = new Date();

  headerForm: FormGroup;
  onSelectdropdown: boolean = true;
  filterData: any;
  dataSource: MatTableDataSource<any>;
  noRecord: any;
  UrnFromURL: any;
  entityId: any;
  entityName:any;
  afterApply:boolean=false;



  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('tSort') tSort: MatSort;

  form1: any = {};

  dataSubject = new BehaviorSubject<any[]>([]);
  
  displayedColumns2: string[] = ['CST_RefNo', 
                               'CST_ID', 
                               'CST_Name', 
                               'CST_Brand', 
                               'CST_Content', 
                               'createdAt', 
                               'CST_Status',
                               'DLT_Status'];

  constructor(
    private fb: FormBuilder,
    private es: APIEntityService,
    private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private _route: ActivatedRoute,
    private router: Router) {

    this._route.params.subscribe((params) => {
      this.UrnFromURL = params['urn'];
    })

  }

  get f() { return this.headerForm.controls; }
  attachmentList: any = [];

  ngOnInit() {
    this.maxDate.setDate(new Date().getDate());

    this.headerForm = this.fb.group({
      entity_id: ['',],
      // industry_type: ['',],
      industry_category: ['',],
      org_name: ['',],

    });

    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.entityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME);
    this.getCsWorklist(this.entityId);

	this.getContentEntityDetails(this.entityId)
    //this.getDiabledFieldsData();
  }

  	getContentEntityDetails(entityId) {
		let data = {  
		  "entity_id": entityId,     
		}
		this.es.getContentEntityDetails(data)
		  .subscribe(r => {
			this.headerForm.controls['entity_id'].setValue(this.entityName);  
			this.headerForm.controls['entity_id'].disable(); 
			console.log("r[0 ",r[0]);			
			console.log("r[0].etype ",r[0].etype);
			console.log("rr[0].name ",r[0].name);
			switch(r[0].etype){
				case 'P':
					this.headerForm.controls['industry_category'].setValue('Private');
					break;
				case 'G':
					this.headerForm.controls['industry_category'].setValue('Government');
					break;
				case 'S':
					this.headerForm.controls['industry_category'].setValue('SEBI');
					break;
				case 'U':
					this.headerForm.controls['industry_category'].setValue('Public Limited Company');
					break;
				case 'O':
					this.headerForm.controls['industry_category'].setValue('Others');
					break;
				default:
					this.headerForm.controls['industry_category'].setValue('');
					break;
			} 
			
			this.headerForm.controls['org_name'].setValue(r[0].name);
			this.headerForm.controls['org_name'].disable();  
		})
	}
	
  getDiabledFieldsData() {

    this.es.GetEntityConsentTemplate(this.entityId).subscribe(result => {
      console.log("new data " + result);
      this.onChangeDataSource1(result);
    })
  }

  onChangeDataSource1(res) {
    console.log("values1" + res.message);
    this.headerForm.controls['entity_id'].setValue(res.message.Entity_ID)
    this.headerForm.controls['industry_category'].setValue(res.message.Industry_Cat)
    this.headerForm.controls['org_name'].setValue(res.message.Entity_OrganizationName)

  }

  
  showCSTinfo(name, content) {
    this.$modal.promptModal({
       title: "Consent Template Content ",
       msg: content
    });
  }
  

  onSubmit() {
    if (this.headerForm.invalid) {
      //  this.disableForm = true;
      let invalid = [];
      let controls = this.headerForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      return;
    }
    this.EntityTemplate();
  }

  EntityTemplate() {
    let Entity_ID = this.headerForm.get("entity_id").value;
    let Industry_Cat = this.headerForm.get("industry_category").value;
    let Entity_OrganizationName = this.headerForm.get("org_name").value;

    const headerForm = new FormData();
    headerForm.append('Entity_ID', Entity_ID);
    headerForm.append('Industry_Cat', Industry_Cat);
    headerForm.append('Entity_OrganizationName', Entity_OrganizationName);

    headerForm.append('Entity_Class', "PE");
    headerForm.append('CST_CreatedDate', currentdat);

    this.es.entityConsentTemplate(headerForm)
      .subscribe(r => {
        try {
          if (r.validation_1) {
            this.$modal.errorModal({
              title: 'New Consent Template request by PE',
              msg: 'Entity Id exists!'
            });
          }
        }
        catch (e) {
          console.log("catch in registration", e);
        }
      });
  }


  getCsWorklist(peId) {
    this.es.getCsTemplateReports(peId).subscribe(result => {
      console.log("new data " + result);
      this.afterApply=true;
      this.onChangeDataSource(result);

    })
  }


  onChangeDataSource(value) {

    console.log("values" + value);
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.tSort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

  onOptionsSelected(data) {
    if (data === "TemplateStatus") {
      this.onSelectdropdown = false;
    } else {
      this.onSelectdropdown = true;
    }
    console.log(data);

  }
  // enddateError=false
  // enddateError1=true;
  // addEventEnddate(event: MatDatepickerInputEvent<Date>) {
  //   if(event.value){
  //    this.enddateError1=false;
  //    this.enddateError=false;
  //   }
  // }
  searchRequired:boolean=false;
  errorSerch(){
    if(this.form1.searchBy && !this.form1.search){
      this.searchRequired=true;
    }else{
      this.searchRequired=false;
  
    }
  }

  onSubmitFilter(filterForm,form) {
    if(!form.valid){
      return true;
    }
    if(this.form1.searchBy && !this.form1.search){
      this.searchRequired=true;
      return true;
   }else{
     this.searchRequired=false;
 
   }
          let fdate,ldate;
      if(filterForm.startDate){
       fdate = formatDate(filterForm.startDate , 'yyyy-MM-dd', 'en-US', '+0530');
      }
      // if(this.enddateError1 && filterForm.startDate){
      //   this.enddateError=true; 
      //   return true;
      // }
      if(filterForm.endDate){
       ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
      }
      if(filterForm.startDate && !filterForm.endDate){
        ldate=formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
        
      }
      let searchVal;
      if(this.form1.search){
          searchVal=this.form1.search.trim();
      } 

      let TemplateName=filterForm.searchBy;
      let data={
        "filterType": filterForm.searchBy,
        [TemplateName]: searchVal,
        "Start_Date":fdate ,
        "End_Date": ldate,
        'EntityID':this.entityId

        
      }
    //   var difference_in_Time=new Date(ldate).getTime()-new Date(fdate).getTime()
    //  var difference_in_Days=difference_in_Time/(1000*3600*24)
    //  console.log("difference_in_Timedifference_in_Time in days",difference_in_Time)
    //  if(fdate!=""&&ldate!="" &&difference_in_Days>30){
    //   alert("Date Difference should not be more than 30 days")
    //  }
     

    this.getAllEntityForApprovalFilters(data);
    // Here we have call the funtion to retrieve data and change datasource
  }

  getAllEntityForApprovalFilters(data) {
    this.es.getAllEntityForApprovalFilters(data)
      .subscribe(r => {
        this.filterData = r;
        this.onChangeDataSource(this.filterData);
        console.log("12345 :", this.filterData);
      })

  }

//   enddateError=false
// addEvent(event: MatDatepickerInputEvent<Date>) {
//     if(event.value){
//      this.enddateError=true;
//     }
// }
// addEventEnddate(event: MatDatepickerInputEvent<Date>) {
//   if(event.value){
//    this.enddateError=false;
//   }
// } 
  reset() {

    this.getCsWorklist(this.entityId);
 //  this.enddateError=false;
    this.onSelectdropdown=true;
    //this.enddateError=false;
    //this.enddateError1=true;
    this.searchRequired=false;
    this.afterApply=false;

  }


  downloadrejectedcsvfile(Status) {

    let data;
    if (Object.keys(this.form1).length !== 0 && this.afterApply) {
      // const fdate = formatDate(this.form1.stDate, 'dd-MM-yyyy', 'en-US', '+0530');
      // const ldate = formatDate(this.form1.enDate, 'dd-MM-yyyy', 'en-US', '+0530');
      let fdate =this.form1.stDate ? formatDate(this.form1.stDate , 'yyyy-MM-dd', 'en-US', '+0530') : undefined;
      let ldate = this.form1.enDate ? formatDate(this.form1.enDate, 'yyyy-MM-dd', 'en-US', '+0530') : undefined;
      let TemplateName=this.form1.searchBy;
      if(this.form1.stDate && !this.form1.enDate){
        ldate=formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
        
      }
     data={
      "filterType": this.form1.searchBy,
      [TemplateName]: this.form1.search,
      "Start_Date":fdate ,
      "End_Date": ldate,
      'EntityID':this.entityId
    }
    }
    else {
      data = {
        'EntityID':this.entityId
      }
    }
    // this.getAllEntityForApprovalFilters(data);

    var fileName;
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
    this.es.downloadentitytemplatessvfile(data).subscribe(r => {
     // if (Status == 'C') {
        fileName = currentdat + 'Entity-Consent-Reports.csv';
    //  }
      importedSaveAs(r, fileName)
      //  this.downloadFile(r, Batch_Id);
      this.afterApply=false;   
      this.$modal.successModal({
        title: 'Entity UI - Consent Template Reports',
        msg: 'File has been downloaded Successfully'
      });
    })
  }


}
